/**
 * 其知网 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:140px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择注册开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择注册结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleExport" title="批量导入用户">用户导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="sendAll" title="批量发送通知消息">发送消息</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="uid" v-if="idShow">
      </el-table-column>
      <el-table-column prop="username" align="center" label="用户名" width="140px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_mobile" align="center" label="联系方式" width="100px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_address" align="center" label="地址" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="pc_company" align="center" label="所属企业" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="mobile" align="center" label="头像" width="80px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.pc_head">
        　  <img :src="scope.row.pc_head" width="40" height="40" class="head_pic"/>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="qq" align="center" label="QQ" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="account_name" align="center" label="账户类型" width="80px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="last_login_time" align="center" label="上次登录时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reg_time" align="center" label="注册时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="240px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="primary" @click="send(scope.$index, scope.row)" title="发送消息通知">消息</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="微信昵称">
              <el-input size="small" v-model="infoForm.name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="用户位置">
              <el-input size="small" v-model="infoForm.address" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="注册时间">
              <el-input size="small" v-model="infoForm.reg_time" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
                <img :src="infoForm.head" width="70%" height="70%" class="head_pic"/>
            </el-form-item>       
          </el-col>
        </el-row>
        <!-- <el-form-item label="备注">
          <el-input size="small" v-model="infoForm.remark" auto-complete="off" placeholder="请输入微信证书路径" disabled></el-input>
        </el-form-item> -->
      </el-form>
    </el-dialog>

    <!-- 消息发送界面(单发) -->
    <el-dialog :title="sendTitle" :visible.sync="sendFormVisible" width="50%" @click="closeDialog('sendForm')">
      <el-form label-width="120px" ref="sendForm" :model="sendForm" :rules="sendFormRules">
        <el-row>
            <el-form-item label="通知标题" prop="title">
              <el-input size="small" v-model="sendForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="通知内容" prop="content">
              <el-input size="small" type="textarea" v-model="sendForm.content" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitSend('sendForm')">发布</el-button>
              <el-button size="mini" @click='closeDialog("sendForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 消息发送界面(群发) -->
    <el-dialog :title="sendTitle" :visible.sync="sendCheckFormVisible" width="50%" @click="closeDialog('sendCheckForm')">
      <el-form label-width="120px" ref="sendCheckForm" :model="sendCheckForm" :rules="sendCheckFormRules">
        <el-row>
            <el-form-item label="通知标题" prop="title">
              <el-input size="small" v-model="sendCheckForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="通知内容" prop="content">
              <el-input size="small" type="textarea" v-model="sendCheckForm.content" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitCheckSend('sendCheckForm')">发布</el-button>
              <el-button size="mini" @click='closeDialog("sendCheckForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

     <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M</div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webUserList, webSendUser, webSendUserCheck, webUrl } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      sendFormVisible: false, //控制发送消息(单发)页面显示与隐藏
      excelFormVisible: false, //控制批量导入页面显示与隐藏
      sendCheckFormVisible: false, //控制发送消息(群发)页面显示与隐藏
      title: '用户详情',
      sendTitle: '',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      infoForm: {
        id: '',
        mobile: '',
        name: '',
        reg_time: '',
        address: '',
        head: '',
        token: localStorage.getItem('logintoken')
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        name: '',
        mobile: '',
        // token: localStorage.getItem('logintoken')
      },
      sendForm: {
        uid: '',
        title: '',
        content: ''
      },
      sendCheckForm: {
        ids: '',
        title: '',
        content: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/users/importUserExcel',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      sendFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      },
      sendCheckFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/users/importUserExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webUserList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        
        const idStr = JSON.stringify(idsArr)
        console.log(idStr)
        // console.log(data)
        window.location.href = wechatUrl + "/admin/patent/exportUserExcel?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = wechatUrl + "/admin/patent/exportUserAllExcel?name="+this.formInline.name+"&mobile="+this.formInline.mobile+"&start_time="+this.formInline.start_time+"&end_time="+this.formInline.end_time;
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    sendAll() {
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      this.sendCheckFormVisible = true
      this.sendCheckForm.ids = JSON.stringify(idsArr)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 性别
    wxsexFormat(row,column){
      if(row.wx_qrcode_sex){
        if(row.wx_qrcode_sex == 1){
                  return '男'
              }else if(row.wx_qrcode_sex == 2){
                  return '女'
              }else{
                return '保密'
              }
      }else{
        return ''
      }
    },
     qqsexFormat(row,column){
      if(row.qq_sex){
        if(row.qq_sex == 1){
                  return '男'
              }else if(row.qq_sex == 2){
                  return '女'
              }else{
                return '保密'
              }
      }else{
        return ''
      }
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
     // 显示Excel导入页面
    handleExport: function(){
      this.title = '批量导入Excel'
      this.excelFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    submitSend(sendData){
    // 校验参数
      this.$refs[sendData].validate(valid => {
        if(valid){
          // 提交通知
          const sendParam = this.sendForm
          webSendUser(sendParam)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.sendFormVisible = false
                this.sendForm.id = ''
                this.sendForm.title = ''
                this.sendForm.content = ''
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
        }else{
          return false;
        }
      })
    },
    submitCheckSend(sendCheckData) {
 // 校验参数
      this.$refs[sendCheckData].validate(valid => {
        if(valid){
          // 提交通知
          const sendParam = this.sendCheckForm
          webSendUserCheck(sendParam)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.sendCheckFormVisible = false
                this.sendCheckForm.ids = ''
                this.sendCheckForm.title = ''
                this.sendCheckForm.content = ''
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
        }else{
          return false;
        }
      })
    },
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
     // 显示发送消息界面
    send(index, row) {
      console.log(row)
      this.sendFormVisible = true
      this.sendForm.uid = row.uid
      this.sendTitle = '发送通知'
      console.log(this.sendForm)
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'sendForm'){
        this.sendFormVisible = false
      }else if(formName == 'sendCheckForm'){
        this.sendCheckFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/user.vue